import { Auth } from '@core/auth';

import {
    getSelectedBillingAdviserId,
    resolveBillingContextAdviserAccount
} from '@packages/rate-plans/utils/investorBillingSubscriptionValidation';

import i18n from '@plugins/i18n';

import BaseValidator from './BaseValidator';

export class InvestorAdviserBillingValidator extends BaseValidator {
    static key = 'investorAdviserBilling';

    static getBillingContextAdviserAccount(model = null) {
        return resolveBillingContextAdviserAccount(model, Auth(), getSelectedBillingAdviserId());
    }

    /**
     * Valid once Option A or B has been chosen on the resolved adviser relationship. The flag is
     * hydrated onto the adviser account from the relationship, see
     * hydrateOrganisationAdviserRelationship.
     */
    static validator(model = null) {
        const account = InvestorAdviserBillingValidator.getBillingContextAdviserAccount(model);

        if (typeof account?.adviser_fees_agreed_externally === 'boolean') {
            return true;
        }

        return i18n.t('validator.adviser_fees_or_external');
    }

    static arguments() {
        return [];
    }
}

export default InvestorAdviserBillingValidator;
